<template>
    <div class="list-container">
        <el-table :data="tableData" border style="width: 100%" key="project">
            <el-table-column prop="id" label="编号" width="80">
            </el-table-column>
            <el-table-column prop="name" label="姓名">
            </el-table-column>
            <el-table-column prop="phone" label="联系方式">
            </el-table-column>
            <el-table-column prop="info" label="留言" width="300">
            </el-table-column>
            <el-table-column prop="create_time" label="创建日期">
            </el-table-column>
        </el-table>
        <div class="pagination-views">
            <el-pagination background layout="prev, pager, next" :total="pagelist.total" :page-size="pagelist.size"
                :current-page.sync="pagelist.pageNO" @current-change="handleCurrentChange">
            </el-pagination>
        </div>
        <div class="w30" v-if="dialogVisible">
            <el-dialog title="请先验证身份" :visible.sync="dialogVisible" :before-close="handleClose" :show-close="false">
                <el-form ref="form" :model="form" label-width="80px">
                    <el-form-item label="登录名:">
                        <el-input v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="密码:">
                        <el-input v-model="form.pas" show-password></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="gohome">取 消</el-button>
                    <el-button type="primary" @click="submit">确 定</el-button>
                </span>
            </el-dialog>
        </div>

    </div>
</template>

<script>
import axios from 'axios';
import { baseUrl } from '../utils/baseUrl'
export default {
    data() {
        return {
            dialogVisible: true,
            form: {
                name: '',
                pas: '',
            },
            tableData: [],
            pagelist: {
                size: 10,
                pageNO: 1,
                total: 10,
            },
            mybaseurl: '',
        };
    },
    mounted() {
        this.mybaseurl = baseUrl
        if (sessionStorage.getItem('mytokenycite')) {
            this.dialogVisible = false
            this.conditionalFiltering()
        }


    },
    methods: {
        //分页的回调
        handleCurrentChange(val) {
            this.pagelist.pageNO = val;
            this.conditionalFiltering(val);
        },
        //获取筛选列表
        conditionalFiltering(pno) {
            let temp = isNaN(Number.parseInt(pno)) ? 1 : pno;
            axios.get(`${this.mybaseurl}/gt_info/`, {
                params: {
                    page: temp,
                    size: this.pagelist.size,
                },
            })
                .then((res) => {
                    let temp = res.data;
                    this.pagelist.total = temp.count;
                    this.tableData = temp.results;
                });
            this.$nextTick(() => {
                this.pagelist.pageNO = temp;
            });
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                })
                .catch(_ => { });
        },
        gohome() {
            this.$router.push({
                name: "Home",
                params: {
                    change: 888
                }
            });
        },
        submit() {
            if (this.form.name === 'admin' && this.form.pas === "123456") {
                sessionStorage.setItem('mytokenycite', true)
                this.conditionalFiltering()
                this.dialogVisible = false
            } else {
                this.$message.warning("请进行身份验证");
            }
        }
    }

}
</script>

<style>
.list-container {
    position: relative;
    min-height: 100vh;
    width: 100%;
    padding: 80px;
}

.el-button--primary span {
    color: #fff;
}

.pagination-views {
    position: absolute;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 20px;
    left: 0;
}

.w30 .el-dialog {
    width: 30% !important;
}

@media screen and (max-width:1023px) {
    .w30 .el-dialog {
        width: 90% !important;
    }
}
</style>